import { render, staticRenderFns } from "./LocalsCreationFormBody.vue?vue&type=template&id=06c44a41&scoped=true"
import script from "./LocalsCreationFormBody.vue?vue&type=script&lang=js"
export * from "./LocalsCreationFormBody.vue?vue&type=script&lang=js"
import style0 from "./LocalsCreationFormBody.vue?vue&type=style&index=0&id=06c44a41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c44a41",
  null
  
)

export default component.exports